export default __webpack_public_path__ + "static/media/fnd.ba41b455.jpg";